"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var kaltura_player_js_1 = require("@playkit-js/kaltura-player-js");
var ui_managers_1 = require("./ui-managers");
(0, kaltura_player_js_1.registerPlugin)(ui_managers_1.pluginName, ui_managers_1.UIManagers);
